<!-- 空白的布局页。主要用在布局特殊的页面中 -->
<template>
  <div>
    <router-view></router-view>
  </div>
</template>
  
<script>

export default {
  name: 'BlankLayout'
}
</script>
  
<style scoped>

</style>
  